import React from 'react';
import { ImageFadeIn } from '../components/animations/ImageFadeIn';
import { ScrollReveal } from '../components/animations/ScrollReveal';
import { useDonateByMail } from '../contexts/DonateByMailContext';
import { CheckCircle, Clock, Users, Heart, Shield, Target, Building, Zap } from 'lucide-react';
const RoadmapPage = () => {
  const {
    openDonateByMail
  } = useDonateByMail();
  return <div className="w-full min-h-screen bg-white" data-id="element-745" data-mp="dj2asef73ur9">
      {/* Hero Section */}
      <div className="relative min-h-[60vh] flex items-center" data-id="element-746" data-mp="ih3risp5fhzk">
        <div className="absolute inset-0 z-0" data-id="element-747" data-mp="ifj0hd21mh6g">
          <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/nSwuHbb12i4azWUVYSdDyT/960x0.webp" alt="Jerusalem Old City with Dome of the Rock at sunset" className="w-full h-full object-cover" data-id="element-748" data-mp="mifo5i6fx3h9" />
          <div className="absolute inset-0 bg-black/50" data-id="element-749" data-mp="2ocewpvs6h6q9"></div>
        </div>
        <div className="relative z-10 w-full pt-36 sm:pt-52 md:pt-56 pb-16 sm:pb-20" data-id="element-750" data-mp="2ta6pst4k6yw1">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center" data-id="element-751" data-mp="2gwd1skia549k">
            <h1 className="text-3xl sm:text-5xl md:text-6xl font-bold text-white tracking-tight mb-4 sm:mb-6" data-id="element-752" data-mp="2c436eoyebbzw">
              Implementation Timeline
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl text-white/90 max-w-3xl mx-auto font-light leading-relaxed" data-id="element-753" data-mp="280x57vq54b0a">
              Building a nationwide shield of civilian resilience through
              comprehensive training
            </p>
          </div>
        </div>
      </div>
      {/* Vision Statement */}
      <ScrollReveal animation="fade" data-id="element-754" data-mp="2qtiv7zed97cy">
        <div className="py-16 sm:py-24 bg-white" data-id="element-755" data-mp="2qsg5huss5aym">
          <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-756" data-mp="2qvc5doo6u9pp">
            <div className="text-center mb-8" data-id="element-757" data-mp="2ltmqtz1rbdwv">
              <div className="inline-flex items-center justify-center mb-6" data-id="element-758" data-mp="1fecduv9nzywq">
                <Heart className="w-8 h-8 text-red-500 mr-3" data-id="element-759" data-mp="1fc9e3jipmret" />
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight" data-id="element-760" data-mp="1ae7xd58rb46i">
                  Our Vision
                </h2>
              </div>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-761" data-mp="1gv9cw9i029zz">
                Establishing Regional Civilian Training Centers across Israel
              </p>
            </div>
            <div className="prose prose-lg max-w-none text-gray-700 mb-6" data-id="element-762" data-mp="12y2uig16udba">
              <p data-id="element-763" data-mp="17t03jmygwmo6">
                Families are currently being trained in Samaria as we work
                towards construction of the Samaria Regional Training Center
                (SRTC). The Samaria Regional Training Center (SRTC) will serve
                as a permanent hub for civilian security and emergency response
                training, offering free to low cost instruction to Israeli
                civilians. No comparable center currently exists in Israel, and
                the development of this facility will establish an ongoing,
                powerful, and sustained capability to ensure the local
                population is fully prepared for all types of crisis situations.
                Our goal is to train at least 50,000 civilians per year, with 7
                full-time Israeli staff members and experienced instructors
                ensuring that Israeli communities receive proactive training in
                addressing emerging security threats.
              </p>
            </div>
            <ScrollReveal animation="scale" delay={0.2} data-id="element-764" data-mp="eiygxryrfvpa">
              <div className="relative mt-10 mb-8" data-id="element-765" data-mp="ehna1ja0q7ty">
                <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/iJxhKShBKb1wywLqvcgR3s/israel-flag-masada-1024x683.jpg" alt="Israeli flag flying over Masada with Dead Sea view" className="w-full h-auto rounded-xl shadow-lg" data-id="element-766" data-mp="9kokle1aup23" />
              </div>
            </ScrollReveal>
          </div>
        </div>
      </ScrollReveal>
      {/* Current Phase - Highlighted */}
      <ScrollReveal animation="fade" data-id="element-767" data-mp="t9z0ot4yjc0q">
        <div className="py-16 sm:py-24 bg-blue-50" data-id="element-768" data-mp="2mr4npr60y02k">
          <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-769" data-mp="2mqborcdb4euz">
            <div className="text-center mb-16" data-id="element-770" data-mp="2rpenyg6lvqv1">
              <div className="inline-flex items-center justify-center mb-6" data-id="element-771" data-mp="2ro3ebzqhbow0">
                <Zap className="w-8 h-8 text-blue-500 mr-3" data-id="element-772" data-mp="2whzaqxr3h3p2" />
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight" data-id="element-773" data-mp="31g97vdwdqedb">
                  Where We Are Today
                </h2>
              </div>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-774" data-mp="23ubv7x4ol39a">
                Immediate action while building for the future
              </p>
            </div>
            <ScrollReveal animation="slide-up" data-id="element-775" data-mp="2dolnletmi1k0">
              <div className="bg-white p-8 sm:p-10 rounded-xl shadow-sm border border-gray-100 mb-12 relative overflow-hidden" data-id="element-776" data-mp="2hribnl1xmpvc">
                <div className="absolute top-0 right-0 bg-green-100 text-green-800 px-4 py-2 rounded-bl-lg font-medium text-sm" data-id="element-777" data-mp="3p4aay7ash2lc">
                  In Progress
                </div>
                <div className="flex items-start gap-6" data-id="element-778" data-mp="1hk3h53ygn05x">
                  <div className="hidden sm:block flex-shrink-0" data-id="element-779" data-mp="1hloawrcyaf2q">
                    <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-780" data-mp="1dj1iao8ggq4h">
                      <Clock className="w-8 h-8 text-blue-600" data-id="element-781" data-mp="18pyt0sapo2u3" />
                    </div>
                  </div>
                  <div data-id="element-782" data-mp="13rwztejkmn4w">
                    <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-783" data-mp="13qcf0gn26ik8">
                      Phase 1: Approval & Funding (Months 1-6)
                    </h3>
                    <div className="prose prose-lg text-gray-700" data-id="element-784" data-mp="tsfwh3rsklc3">
                      <p data-id="element-785" data-mp="prm869aft4io">
                        While we secure final approvals and begin construction
                        on the permanent training center, we're already bringing
                        critical training to the communities that need it most.
                      </p>
                    </div>
                    <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-786" data-mp="2f8dh7deordue">
                      <ScrollReveal animation="slide-left" delay={0.1} data-id="element-787" data-mp="2ybp4tnauyd3m">
                        <div className="bg-blue-50 p-6 rounded-lg" data-id="element-788" data-mp="332nomwv21tbm">
                          <h4 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-789" data-mp="333yssxsex339">
                            Immediate Community Training
                          </h4>
                          <ul className="space-y-3" data-id="element-790" data-mp="2ubexa67f3emn">
                            <li className="flex items-start" data-id="element-791" data-mp="3hzy8athuq5if">
                              <Clock className="w-5 h-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-792" data-mp="3i0g11g5b21ll" />
                              <span className="text-gray-700" data-id="element-793" data-mp="3m0zzqo5j1d9u">
                                Secure $750,000 in U.S. donor and partner
                                funding to enhance current training underway in
                                regional areas.
                              </span>
                            </li>
                            <li className="flex items-start" data-id="element-794" data-mp="21loj5x5sccqj">
                              <Clock className="w-5 h-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-795" data-mp="21n9e3nw0hxox" />
                              <span className="text-gray-700" data-id="element-796" data-mp="1u0m2cmeudpsf">
                                Deploy portable 2 additional portable MILO Range
                                simulators to high-risk communities and add 2
                                additional Israeli trainers
                              </span>
                            </li>
                            <li className="flex items-start" data-id="element-797" data-mp="1adwohxfe9ks2">
                              <Clock className="w-5 h-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-798" data-mp="1ac3jsnocdamp" />
                              <span className="text-gray-700" data-id="element-799" data-mp="16ahz4g5kfs1y">
                                Develop realistic community-based training in
                                emergency medical care and weapons
                                familiarization
                              </span>
                            </li>
                          </ul>
                        </div>
                      </ScrollReveal>
                      <ScrollReveal animation="slide-right" delay={0.1} data-id="element-800" data-mp="22s0ikinn4mx">
                        <div className="bg-blue-50 p-6 rounded-lg" data-id="element-801" data-mp="24lb2awe2907">
                          <h4 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-802" data-mp="65eyz49tznt3">
                            Site Development
                          </h4>
                          <ul className="space-y-3" data-id="element-803" data-mp="g2jh8t0k2z4m">
                            <li className="flex items-start" data-id="element-804" data-mp="g44e4paceu5n">
                              <CheckCircle className="w-5 h-5 text-green-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-805" data-mp="l25uv3kaqhdy" />
                              <span className="text-gray-700" data-id="element-806" data-mp="p2g1mifwxbtv">
                                Land has been zoned and approved for the center
                              </span>
                            </li>
                            <li className="flex items-start" data-id="element-807" data-mp="yrzpk2ihfvvl">
                              <Clock className="w-5 h-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-808" data-mp="13sdvnf0iwvqz" />
                              <span className="text-gray-700" data-id="element-809" data-mp="18qyx1hrihlh0">
                                Infrastructure planning underway with approved
                                zoning
                              </span>
                            </li>
                            <li className="flex items-start" data-id="element-810" data-mp="2o8lfty2w1ibt">
                              <Clock className="w-5 h-5 text-blue-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-811" data-mp="2jajwrd5gpj0c" />
                              <span className="text-gray-700" data-id="element-812" data-mp="2ecic4nse1bmr">
                                Begin immediate construction of two civilian
                                dedicated live fire ranges
                              </span>
                            </li>
                          </ul>
                        </div>
                      </ScrollReveal>
                    </div>
                  </div>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </ScrollReveal>
      {/* The Journey Ahead */}
      <ScrollReveal animation="fade" data-id="element-813" data-mp="3usbl1kpbjxl6">
        <div className="py-16 sm:py-24 bg-white" data-id="element-814" data-mp="3pz08r41qmolv">
          <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-815" data-mp="3py7c4vwhtfhg">
            <div className="text-center mb-16" data-id="element-816" data-mp="3vsn4rdptyuy0">
              <div className="inline-flex items-center justify-center mb-6" data-id="element-817" data-mp="3vvhp758ugfrf">
                <Target className="w-8 h-8 text-blue-500 mr-3" data-id="element-818" data-mp="3rte9u5j20r0v" />
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight" data-id="element-819" data-mp="9mgp9m0l5f3r">
                  The Journey Ahead
                </h2>
              </div>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-820" data-mp="imvdat4xp8ay">
                Our path to building nationwide civilian resilience
              </p>
            </div>
            <div className="space-y-16" data-id="element-821" data-mp="el1givxv0og2">
              {/* Phase 2 */}
              <ScrollReveal animation="slide-up" data-id="element-822" data-mp="sbd88tqj8l6o">
                <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-823" data-mp="ndlgq0tsv130">
                  <div className="w-full md:w-2/5" data-id="element-824" data-mp="nfoh9eskwclz">
                    <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/3emtZQ7VsFWHjTbEYziWS7/cpr_training.jpg" alt="Training center construction" className="w-full h-auto rounded-lg shadow-lg" data-id="element-825" data-mp="12a2usztditt9" />
                  </div>
                  <div className="w-full md:w-3/5" data-id="element-826" data-mp="1kxv1z0virwps">
                    <div className="flex items-center mb-4" data-id="element-827" data-mp="16zncfe0tbxon">
                      <Building className="w-7 h-7 text-blue-500 mr-3" data-id="element-828" data-mp="16z595xfqgj78" />
                      <h3 className="text-2xl font-bold text-gray-900" data-id="element-829" data-mp="1bxf0fwyc6znk">
                        Phase 2: Site Development & Construction
                      </h3>
                    </div>
                    <p className="text-gray-500 mb-4" data-id="element-830" data-mp="120ka41c7w5kd">Months 1-12</p>
                    <div className="prose prose-lg text-gray-700" data-id="element-831" data-mp="o8vsxjn42qwj">
                      <p data-id="element-832" data-mp="oaqf11a4cp27">
                        As construction progresses, we'll complete all training
                        facilities and prepare for full-scale operations. This
                        includes:
                      </p>
                      <ul data-id="element-833" data-mp="jac6li4lvd3n">
                        <li data-id="element-834" data-mp="j8hmu752lr15">
                          - Construct 20,000 SF classroom building with 3 MILO
                          Range simulators
                        </li>
                        <li data-id="element-835" data-mp="3rjlhzuahg0eh">
                          - Build 25-bed dormitory (10 rooms with 2 beds; 5
                          rooms with queen beds for couples)
                        </li>
                        <li data-id="element-836" data-mp="3hmgunr4whyw3">
                          - Create full-service dining hall with capacity for
                          150 people
                        </li>
                        <li data-id="element-837" data-mp="e4yyigyhqgbi">
                          - Develop tactical training town with integrated
                          training roadways
                        </li>
                        <li data-id="element-838" data-mp="97yuebl7bnn1">
                          - Establish administrative offices and security hubs
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
              {/* Phase 3 */}
              <ScrollReveal animation="slide-up" data-id="element-839" data-mp="2ovp171f7zocg">
                <div className="flex flex-col md:flex-row-reverse gap-8 items-center" data-id="element-840" data-mp="14fhiynwf1bu9">
                  <div className="w-full md:w-2/5" data-id="element-841" data-mp="19dssexistkby">
                    <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/fgT2UYSUqZLvWeymTwzsmW/Screenshot_2025-06-06_at_5.11.03_PM.png" alt="Instructor training session" className="w-full h-auto rounded-lg shadow-lg" data-id="element-842" data-mp="19elv9nemzpot" />
                  </div>
                  <div className="w-full md:w-3/5" data-id="element-843" data-mp="1s4a7w0emejfd">
                    <div className="flex items-center mb-4" data-id="element-844" data-mp="1s2z5a3wwvhpu">
                      <Users className="w-7 h-7 text-blue-500 mr-3" data-id="element-845" data-mp="1x34xbl73f68g" />
                      <h3 className="text-2xl font-bold text-gray-900" data-id="element-846" data-mp="1x1ttjldndyhc">
                        Phase 3: Curriculum Development & Instructor Training
                      </h3>
                    </div>
                    <p className="text-gray-500 mb-4" data-id="element-847" data-mp="7op2vq9hfjsh">Months 9-12</p>
                    <div className="prose prose-lg text-gray-700" data-id="element-848" data-mp="7oyufia6dz0a">
                      <p data-id="element-849" data-mp="1y4ratd9be3o8">
                        With facilities nearing completion, we'll focus on
                        developing comprehensive training programs and preparing
                        our instructor teams:
                      </p>
                      <ul data-id="element-850" data-mp="2745zq89u266m">
                        <li data-id="element-851" data-mp="234dqdtcm7w07">
                          - Develop comprehensive training programs in
                          collaboration with security experts
                        </li>
                        <li data-id="element-852" data-mp="1aghuurys8a50">
                          - Curriculum will be developed in coordination with
                          Israeli doctrine and training standards
                        </li>
                        <li data-id="element-853" data-mp="1jgeci9mr88qk">
                          - Train core Israeli instructor teams with a civilian
                          focus
                        </li>
                        <li data-id="element-854" data-mp="voz6a5rux7a1">
                          - Conduct pilot training sessions with evaluation
                          metrics
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
              {/* Phase 4 */}
              <ScrollReveal animation="slide-up" data-id="element-855" data-mp="7nvt38iiixzs">
                <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-856" data-mp="7p6zlg3cejul">
                  <div className="w-full md:w-2/5" data-id="element-857" data-mp="cnry9b2y4vgx">
                    <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/kvcVKww79qLwCwtTvbHoss/%D7%A6%D7%99%D7%9C%D7%95%D7%9D-%D7%99%D7%97%D7%99%D7%90%D7%9C-%D7%92%D7%95%D7%A8%D7%A4%D7%99%D7%99%D7%9F-127-1024x683.jpg" alt="Full operational training" className="w-full h-auto rounded-lg shadow-lg" data-id="element-858" data-mp="10cb7bsttlca2" />
                  </div>
                  <div className="w-full md:w-3/5" data-id="element-859" data-mp="3b3ulfrkgdxzh">
                    <div className="flex items-center mb-4" data-id="element-860" data-mp="3b31a0dajukb0">
                      <Shield className="w-7 h-7 text-blue-500 mr-3" data-id="element-861" data-mp="3g4i9c4ddxyph" />
                      <h3 className="text-2xl font-bold text-gray-900" data-id="element-862" data-mp="1mkgn7eoqifxm">
                        Phase 4: Operational Launch & Training Programs
                      </h3>
                    </div>
                    <p className="text-gray-500 mb-4" data-id="element-863" data-mp="1cuwz9um5zvvw">Month 12 onward</p>
                    <div className="prose prose-lg text-gray-700" data-id="element-864" data-mp="1csu30suf56iq">
                      <p data-id="element-865" data-mp="17v0x80x12eiz">
                        The Samaria Regional Training Center will launch
                        full-scale operations, becoming a hub for civilian
                        resilience:
                      </p>
                      <ul data-id="element-866" data-mp="yx8esnw0eqrd">
                        <li data-id="element-867" data-mp="tvsyta8ovafu">- Full Samaria Civilian Training Center launch</li>
                        <li data-id="element-868" data-mp="txvsq5cypnpu">
                          - Begin structured training sessions with follow-on
                          assessment frameworks
                        </li>
                        <li data-id="element-869" data-mp="2o7zi6wbqkxj8">- Implement clear training performance metrics</li>
                        <li data-id="element-870" data-mp="2jbikpbind6th"> - Train 50,000 civilians and families annually</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
              {/* Phase 5 */}
              <ScrollReveal animation="slide-up" data-id="element-871" data-mp="2vr8htxufxhv3">
                <div className="flex flex-col md:flex-row-reverse gap-8 items-center" data-id="element-872" data-mp="30lcsar2x080x">
                  <div className="w-full md:w-2/5" data-id="element-873" data-mp="35jo1r0pasgim">
                    <ImageFadeIn src="https://uploadthingy.s3.us-west-1.amazonaws.com/jop9zBgRujeWdeTtyMQTQf/Screenshot_2025-06-06_at_5.11.07_PM.png" alt="Nationwide expansion" className="w-full h-auto rounded-lg shadow-lg" data-id="element-874" data-mp="35l8ucks1xpdu" />
                  </div>
                  <div className="w-full md:w-3/5" data-id="element-875" data-mp="2mtg3avwjme8r">
                    <div className="flex items-center mb-4" data-id="element-876" data-mp="2mqtsmnecvimb">
                      <Target className="w-7 h-7 text-blue-500 mr-3" data-id="element-877" data-mp="3t7xhbkvx481b" />
                      <h3 className="text-2xl font-bold text-gray-900" data-id="element-878" data-mp="22fkahyhfiof">
                        Phase 5: Expansion & Sustainability
                      </h3>
                    </div>
                    <p className="text-gray-500 mb-4" data-id="element-879" data-mp="i7n8fzvnn9ge">Year 2 and beyond</p>
                    <div className="prose prose-lg text-gray-700" data-id="element-880" data-mp="i9gd59mpjjlr">
                      <p data-id="element-881" data-mp="wxkykld5a988">
                        With the Samaria center established, we'll begin
                        expanding our impact across Israel:
                      </p>
                      <ul data-id="element-882" data-mp="15wg8o8jb83gt">
                        <li data-id="element-883" data-mp="15vmw2qxo6jqr">
                          - Evaluate potential additional training centers in
                          high-risk regions (Judea and Galilee)
                        </li>
                        <li data-id="element-884" data-mp="1fuvnpd52bm9y">
                          - Expand partnership networks for sustained financial
                          backing and funding
                        </li>
                        <li data-id="element-885" data-mp="3hntopw8ztl5z">
                          - Establish mobile training units for broader reach
                          into remote communities
                        </li>
                        <li data-id="element-886" data-mp="1s5d826ujreea">
                          {' '}
                          - Develop long-term financial sustainability plan
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </div>
      </ScrollReveal>
      {/* Funding Needs */}
      <ScrollReveal animation="fade" data-id="element-887" data-mp="19ff33zm1q1ev">
        <div className="py-16 sm:py-24 bg-gray-50" data-id="element-888" data-mp="19ec75d9v98s3">
          <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-889" data-mp="1edyo9xstf966">
            <div className="text-center mb-16" data-id="element-890" data-mp="1efji1l7b2o2z">
              <div className="inline-flex items-center justify-center mb-6" data-id="element-891" data-mp="zhhcj5gprsj3">
                <Heart className="w-8 h-8 text-red-500 mr-3" data-id="element-892" data-mp="14g2f3bjfuoap" />
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight" data-id="element-893" data-mp="14gkh6oss7wqj">
                  Funding Needs
                </h2>
              </div>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-894" data-mp="2yubovirjw6jc">
                Supporting the implementation of this critical initiative
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-895" data-mp="azbx8tar1m5y">
              <ScrollReveal animation="slide-left" delay={0.1} data-id="element-896" data-mp="b1ondtqnv2u3">
                <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 relative overflow-hidden" data-id="element-897" data-mp="3temklsw2jhkk">
                  <div className="absolute top-0 right-0 w-32 h-32 -mt-10 -mr-10 bg-blue-50 rounded-full opacity-50" data-id="element-898" data-mp="27s1mg1ersf7"></div>
                  <div className="relative" data-id="element-899" data-mp="pv08v3iedbjv">
                    <div className="flex items-center mb-6" data-id="element-900" data-mp="typw9pnc5n3b">
                      <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center mr-4" data-id="element-901" data-mp="fyngqa2i35r8">
                        <Users className="w-6 h-6 text-blue-600" data-id="element-902" data-mp="kxhz5awk2sat" />
                      </div>
                      <div data-id="element-903" data-mp="30p5skwcd22ov">
                        <div className="text-xl font-bold text-gray-900" data-id="element-904" data-mp="30nup6xmtuwya">
                          Initial Funding
                        </div>
                        <div className="text-sm text-gray-500" data-id="element-905" data-mp="35lw7vhgccu98">$750,000</div>
                      </div>
                    </div>
                    <div className="prose prose-lg text-gray-700" data-id="element-906" data-mp="2t5n101p1x14o">
                      <p data-id="element-907" data-mp="2t7hcyqichiwm">
                        - Continue additional funding to continue immediate
                        regional community-based training in Samaria and Judea,
                        including:
                      </p>
                      <ul data-id="element-908" data-mp="2efpa3dzqlxbs">
                        <li data-id="element-909" data-mp="2eha2awykx46h">
                          {' '}
                          - Purchase of 2 additional portable MILO Range
                          simulators
                        </li>
                        <li data-id="element-910" data-mp="2o7v0ijacc6ov">
                          - 2 trauma manikins, medical kits, and medical
                          supplies
                        </li>
                        <li data-id="element-911" data-mp="1vph8x1fllgy8">
                          - Funding to film approximately 25 realistic scenarios
                          in the region
                        </li>
                        <li data-id="element-912" data-mp="3qt5kmv6ud9vd">
                          - Build two weapons training ranges (one rifle and one
                          pistol) for exclusive civilian training
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
              <ScrollReveal animation="slide-right" delay={0.1} data-id="element-913" data-mp="9cxhndnt8d98">
                <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 relative overflow-hidden" data-id="element-914" data-mp="37u9srqigh7kp">
                  <div className="absolute top-0 right-0 w-32 h-32 -mt-10 -mr-10 bg-blue-50 rounded-full opacity-50" data-id="element-915" data-mp="3csuslotspp8m"></div>
                  <div className="relative" data-id="element-916" data-mp="3hrefbrg7r521">
                    <div className="flex items-center mb-6" data-id="element-917" data-mp="3hutyp6gx7099">
                      <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center mr-4" data-id="element-918" data-mp="3luua0i8q2vc3">
                        <Building className="w-6 h-6 text-blue-600" data-id="element-919" data-mp="x1yudd3oeakb" />
                      </div>
                      <div data-id="element-920" data-mp="11292avb13b1t">
                        <div className="text-xl font-bold text-gray-900" data-id="element-921" data-mp="115odhn1kzzxy">
                          Total Project
                        </div>
                        <div className="text-sm text-gray-500" data-id="element-922" data-mp="2hlc236z0tqyr">
                          $14.1 Million
                        </div>
                      </div>
                    </div>
                    <div className="prose prose-lg text-gray-700" data-id="element-923" data-mp="27v9c7fn74t4n">
                      <p data-id="element-924" data-mp="27sn1x88x7ziq">- Raise approximately $14.1 million to support:</p>
                      <ul data-id="element-925" data-mp="22woblf4187fo">
                        <li data-id="element-926" data-mp="1xwa2ruulwtgl">- Regional training programs</li>
                        <li data-id="element-927" data-mp="1xuqmi48yaiet">- Construction of the Regional Training Center</li>
                        <li data-id="element-928" data-mp="1tvq3akmk9dra">- Initial staffing and operational costs</li>
                        <li data-id="element-929" data-mp="1ow55idj4nbg5">
                          - 2 additional MILO Range Systems for permanent
                          simulation training
                        </li>
                        <li data-id="element-930" data-mp="3j9mw69etwofe">
                          - Live-fire range equipment (moving targets, lighting,
                          coverings)
                        </li>
                        <li data-id="element-931" data-mp="2fzif6bqsfjkw">
                          - Trauma simulation and emergency medical training
                          equipment.
                        </li>
                      </ul>
                    </div>
                    <div className="mt-6 pt-6 border-t border-gray-100" data-id="element-932" data-mp="2bx3ynyalcvws">
                      <div className="bg-blue-50 p-4 rounded-lg" data-id="element-933" data-mp="2bvassl7syfpu">
                        <p className="text-gray-700 font-medium" data-id="element-934" data-mp="1x76gbyzcf0fi">
                          Land has already been zoned and approved for the
                          center, with infrastructure planning underway and
                          formal agreements pending.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </div>
      </ScrollReveal>
      {/* Long-Term Financial Plan */}
      <ScrollReveal animation="fade" data-id="element-935" data-mp="1j7oofaqr371x">
        <div className="py-16 sm:py-24 bg-white" data-id="element-936" data-mp="zmephbp2me85">
          <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-937" data-mp="zn6kolera9xw">
            <div className="text-center mb-16" data-id="element-938" data-mp="uo3dovf7ttna">
              <div className="inline-flex items-center justify-center mb-6" data-id="element-939" data-mp="upeh2u4r0zdv">
                <Shield className="w-8 h-8 text-blue-500 mr-3" data-id="element-940" data-mp="19lm2tyvt28v9" />
                <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight" data-id="element-941" data-mp="14m151rsdg6k4">
                  Long-Term Financial Plan
                </h2>
              </div>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-942" data-mp="1ij659b5emb7g">
                Ensuring sustainability for continued impact
              </p>
            </div>
            <div className="space-y-4 mb-16" data-id="element-943" data-mp="1sasonurwbgla">
              {[0, 1, 2, 3, 4].map(index => <ScrollReveal key={index} animation="slide-up" delay={index * 0.1} data-id="element-944" data-mp="1ncr6dc2anlav">
                  <div className="bg-gray-50 p-6 rounded-lg" data-id="element-945" data-mp="1xaopxm97ktx5">
                    <p className="text-gray-700" data-id="element-946" data-mp="1x8c24sgrrpc6">{fundingModel[index]}</p>
                  </div>
                </ScrollReveal>)}
            </div>
          </div>
        </div>
      </ScrollReveal>
      {/* Call to Action */}
      <ScrollReveal animation="fade" data-id="element-947" data-mp="2eb9ftl4bcolo">
        <div className="py-16 sm:py-24 bg-israel-blue text-white" data-id="element-948" data-mp="2ea83zefh3y2w">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center" data-id="element-949" data-mp="2j3157sbqgoa8">
            <h2 className="text-3xl sm:text-4xl font-bold mb-6 tracking-tight" data-id="element-950" data-mp="2n44oypwwj4gq">
              Help Us Build This Vital Resource
            </h2>
            <p className="text-xl text-white/90 mb-10 max-w-3xl mx-auto" data-id="element-951" data-mp="2s263cxjduflv">
              Become a part of a historic life saving effort, join us in
              protecting the civilian population of Israel.
            </p>
            <div className="flex flex-wrap justify-center gap-6" data-id="element-952" data-mp="320lxzahmc704">
              <a href="https://donate.stripe.com/7sY5kw7P1eO24x90y314401" target="_blank" rel="noopener noreferrer" className="inline-block px-8 py-4 bg-white text-israel-blue font-semibold rounded-lg hover:bg-gray-100 transition-colors text-lg shadow-lg" data-id="element-953" data-mp="12pb32r46ca38">
                Donate Online
              </a>
              <button type="button" onClick={openDonateByMail} className="inline-block px-8 py-4 bg-transparent text-white font-semibold rounded-lg border-2 border-white hover:bg-white/10 transition-colors text-lg" data-id="element-954" data-mp="3c4sn2e28bcx6">
                Donate by Mail
              </button>
              <a href="/support" className="inline-block px-8 py-4 bg-transparent text-white font-semibold rounded-lg border-2 border-white hover:bg-white/10 transition-colors text-lg" data-id="element-955" data-mp="3qtnz3jynbfg">
                Support Our Mission
              </a>
            </div>
          </div>
        </div>
      </ScrollReveal>
    </div>;
};
const fundingModel = ['Donor Sponsorship Programs – Establish annual and lifetime donation tiers in direct support of the training center.', 'Corporate Grants – Pursue funding from Israeli focused organizations.', 'Family Sponsorship Program – Enable donators to sponsor individual/specific family members across Israel', 'Civilian Scholarships – Civilians training scholarship programs to ensure all civilians can attend.', 'Municipal Sponsorship Program – Utilization of government grants to sponsor training.'];
export default RoadmapPage;